module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"eventContactsCount":"0 contact | 1 contact | {n} contacts"},"fr":{"eventContactsCount":"0 contact | 1 contact | {n} contacts"}}')
  delete Component.options._Ctor
}
